<template>
  <div
    v-if="showLoadingState < 6"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productPrices"
    class="m-edition-section-content-subject"
  >
    <div class="m-edition-section-content-subject-steps m-edition-section-content-subject-steps-products">

      <form
        action="#"
        autocomplete="off"
        @submit.prevent="recursionGestiones(productoDivisas.length - 1)"
      >
        <!-- Step 1 -->
        <div class="m-edition-section-content-subject-step-connected">
          <h3>
            <span class="step-number">
              <i :class="+producto.precio.pago ? 'fas fa-shopping-cart' : 'fas fa-gift'"></i>
            </span>
            {{ $t('mEditionProductPricesAndPlansVidroop.steps.first') }}
          </h3>

          <div class="display-flex-row">
            <AtomRadioButtonPrimary
              v-model.number="producto.precio.pago"
              :disabled="buttonPrimary.sending"
              :radio-button-primary="radioButtonPrimary.formaDeVenta.pago"
              :text="$t('mEditionProductPricesAndPlansVidroop.inputs.forma.label.first')"
              :value="1"
              wrapperClass="a-input-side margin-top-small"
            />
            <AtomRadioButtonPrimary
              v-if="!tieneIa"
              v-model.number="producto.precio.pago"
              :disabled="buttonPrimary.sending"
              :radio-button-primary="radioButtonPrimary.formaDeVenta.gratis"
              :text="$t('mEditionProductPricesAndPlansVidroop.inputs.forma.label.second')"
              :value="0"
              wrapperClass="margin-top-small"
            />
          </div>

          <small
            v-if="+producto.precio.pago"
            class="font-weight-light"
          >
            <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.price.charge') }}</i>
          </small>
          <small
            v-else
            class="font-weight-light"
          >
            <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.price.free') }}</i>
          </small>
          <small
            v-if="tieneIa"
            class="display-block font-weight-light margin-top-small"
          >
            <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.artificialIntelligence.free') }}</i>
          </small>
        </div>

        <!-- Step 2 -->
        <div
          v-show="+producto.precio.pago"
          class="m-edition-section-content-subject-step-connected"
        >
          <h3>
            <span class="step-number">
              <i class="fas fa-calendar-check"></i>
            </span>
            {{ $t('mEditionProductPricesAndPlansVidroop.steps.second.charge') }}
          </h3>
          <div class="display-flex-row">
            <AtomRadioButtonPrimary
              v-if="!tieneIa"
              v-model.number="trialPago"
              :disabled="buttonPrimary.sending"
              :radio-button-primary="radioButtonPrimary.periodoPrueba.gratis"
              :text="$t('mEditionProductPricesAndPlansVidroop.inputs.trial.label.first')"
              :value="0"
              wrapperClass="a-input-side margin-top-small"
            />
            <AtomRadioButtonPrimary
              v-model.number="trialPago"
              :disabled="buttonPrimary.sending"
              :radio-button-primary="radioButtonPrimary.periodoPrueba.sinPeriodo"
              :text="$t('mEditionProductPricesAndPlansVidroop.inputs.trial.label.second')"
              :value="2"
              wrapperClass="margin-top-small"
            />
          </div>
          <div class="align-items-baseline display-flex-row">
            <p
              v-show="trialPago < 2"
              class="a-input-side font-weight-light"
            >
              {{ $t('mEditionProductPricesAndPlansVidroop.trialText') }}
            </p>

            <AtomSelectPrimary
              v-show="trialPago < 2"
              v-model.number="producto.precio.trial.intervalo"
              :disabled="buttonPrimary.sending"
              :elements="intervals"
              keyField="id"
              name="trial_intervalo"
              textField="day"
              wrapperClass="a-input-wrapper-row"
            />

            <AtomSelectPrimary
              v-show="trialPago < 2"
              v-model.number="producto.precio.trial.frecuencia"
              :disabled="buttonPrimary.sending"
              :elements="frequencyTypesTrial"
              inputClass="a-input-side"
              keyField="id"
              name="trial_frecuencia"
              textField="name"
              wrapperClass="a-input-wrapper-row"
            />
          </div>
          <small class="font-weight-light">
            <i>{{ trialMessage }}</i>
          </small>
          <small
            v-if="tieneIa"
            class="display-block font-weight-light margin-top-small"
          >
            <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.artificialIntelligence.trial') }}</i>
          </small>
        </div>

        <!-- Step 3 -->
        <div
          v-show="+producto.precio.pago"
          class="m-edition-section-content-subject-step-connected"
        >
          <h3>
            <span class="step-number">
              <i class="fas fa-money-bill"></i>
            </span>
            {{ $t('mEditionProductPricesAndPlansVidroop.steps.third.charge') }}
          </h3>

          <div v-if="!productoDivisas.length">
            <p class="margin-bottom-zero font-weight-regular text-color-vidroop-primary">
              {{ $t('mEditionProductPricesAndPlansVidroop.messages.pointsOfSale.noPointsOfSaleCreated') }}
            </p>
            <router-link
              class="display-flex-row-center font-size-small font-weight-bold margin-top-medium text-color-success"
              :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.salesData.subject')}/${$t('mEditionMenu.billing.salesData.children.createData.subedition')}`"
            >
              <i class="fas fa-plus font-size-xsmall margin-right-xsmall"></i>
              <span>
                {{ $t('mEditionProductPricesAndPlansVidroop.links.pointsOfSale') }}
              </span>
            </router-link>
          </div>

          <div
            v-for="(productoDivisa, index) in productoDivisas"
            :key="productoDivisa.idDivisa"
            class="m-edition-section-content-subject-list"
          >
            <div class="list-item-group">
              <div :class="['m-edition-section-content-subject-list-item', productoDivisas[index].show ? 'list-item-selected' : '']">
                <a
                  class="m-edition-section-content-subject-list-item-data text-transform-capitalize"
                  href="#"
                  @click.prevent="toggleProductoDivisa(index)"
                >
                  <i :class="[productoDivisas[index].show ? 'fas fa-caret-down' : 'fas fa-caret-right', 'margin-right-small']"></i>
                  {{ productoDivisa.divisa.nombre }}
                  <span class="margin-left-small text-color-black-35">
                    {{ productoDivisa.divisa.simbolo }} {{ productoDivisa.divisa.iso_code }}
                  </span>
                </a>
                <span class="m-edition-section-content-subject-list-item-actions">
                  <AtomTogglePrimary
                    v-model="productoDivisa.gestion.activa"
                    :disabled="buttonPrimary.sending || !productoDivisa.updateStateAllowed"
                    name="activa"
                    slider-class="a-toggle-slider-products-primary"
                    type="checkbox"
                  />
                </span>
              </div>
              <transition name="a-transtion-slide">
                <div
                  v-show="productoDivisa.show"
                  class="list-item-edition"
                >
                  <h4 class="font-weight-bold text-color-products-primary">
                    {{ $t('mEditionProductPricesAndPlansVidroop.messages.currency.items.pointOfSale') }}
                  </h4>
                  <div class="display-flex-column list-item-edition-content">
                    <span
                      v-for="punto in puntosDeVenta"
                      :key="punto.id"
                    >
                      <AtomRadioButtonPrimary
                        v-if="punto.activo && punto.divisa_vende && punto.divisa_vende.includes(productoDivisa.divisa.iso_code)"
                        v-model="productoDivisas[index].gestion.punto_venta"
                        :disabled="buttonPrimary.sending"
                        :radio-button-primary="{ labelClass: 'a-radiobutton-products-primary', name: `punto-${productoDivisa.divisa.iso_code}` }"
                        :text="punto.nombre"
                        :value="punto.id"
                        wrapperClass="margin-top-small"
                      />
                    </span>
                  </div>

                  <h4 class="font-weight-bold text-color-products-primary">
                    {{ $t('mEditionProductPricesAndPlansVidroop.messages.currency.items.payments') }}
                  </h4>
                  <div class="display-flex-column list-item-edition-content">
                    <p
                      v-if="productoDivisas[index].gestion.planes === undefined ||
                        productoDivisas[index].gestion.planes.length === 0"
                      class="margin-bottom-zero margin-top-small font-weight-regular text-color-vidroop-primary"
                    >
                      {{ $t('mEditionProductPricesAndPlansVidroop.messages.plan.noPlansCreated') }}
                    </p>

                    <div
                      v-if="productoDivisas[index].gestion.planes"
                      class="display-flex-column margin-bottom-small margin-top-xsmall"
                    >
                      <span
                        v-for="(plan, planIndex) in productoDivisas[index].gestion.planes"
                        :key="plan.id_producto_gestion_plan
                          ? plan.id_producto_gestion_plan
                          : (Math.floor(100000 + Math.random() * 900000)).toString()"
                        :class="['font-weight-light',
                          plan.activo === undefined || plan.activo
                            ? 'margin-bottom-medium margin-top-small'
                            : '']"
                      >
                        <span v-if="plan.activo || !plan.id_producto_gestion_plan">
                          <span>
                            {{ getProductoGestionPlanText(plan, productoDivisas[index].divisa.simbolo, productoDivisas[index].divisa.iso_code) }}
                          </span>
                          <a
                            href="#"
                            class="margin-left-small text-color-danger"
                            :disabled="buttonPrimary.sending"
                            @click.prevent="removePlan(index, planIndex)"
                          >
                            <i class="far fa-trash-alt"></i>
                          </a>
                        </span>
                      </span>
                    </div>

                    <a
                      href="#"
                      class="font-size-small font-weight-bold margin-bottom-medium text-color-success"
                      @click.prevent="toggleFormaDePago(index)"
                    >
                      <i :class="formaDePago[index].show ? 'fas fa-caret-down' : 'fas fa-caret-right'"></i>
                      {{ $t('mEditionProductPricesAndPlansVidroop.links.plan') }}
                    </a>

                    <transition name="a-transtion-slide">
                      <div
                        v-show="formaDePago[index].show"
                        class="margin-left-large"
                      >

                        <div
                          v-if="!element.producto_vidroop"
                          class="display-flex-row-center"
                        >
                          <AtomRadioButtonPrimary
                            v-if="!soloSuscripcion"
                            v-model="formaDePago[index].value"
                            :disabled="buttonPrimary.sending"
                            :radio-button-primary="{ labelClass: 'a-radiobutton-products-primary', name: `forma-de-pago-${productoDivisa.isoCode}` }"
                            text="Contado"
                            :value="1"
                            wrapperClass="margin-top-small"
                            @change="setPlan(index)"
                          />
                          <AtomRadioButtonPrimary
                            v-if="!soloSuscripcion && !soloContado"
                            v-model="formaDePago[index].value"
                            :disabled="buttonPrimary.sending"
                            :radio-button-primary="{ labelClass: 'a-radiobutton-products-primary', name: `forma-de-pago-${productoDivisa.isoCode}` }"
                            text="Cuotas"
                            :value="2"
                            wrapperClass="margin-top-small"
                            @change="setPlan(index)"
                          />
                          <AtomRadioButtonPrimary
                            v-if="!soloContado"
                            v-model="formaDePago[index].value"
                            :disabled="buttonPrimary.sending"
                            :radio-button-primary="{ labelClass: 'a-radiobutton-products-primary', name: `forma-de-pago-${productoDivisa.isoCode}` }"
                            text="Suscripción"
                            :value="0"
                            wrapperClass="margin-top-small"
                            @change="setPlan(index)"
                          />
                        </div>

                        <div class="align-items-baseline display-flex-row">
                          <!-- Contado -->
                          <span
                            v-show="!soloSuscripcion && formaDePago[index].value === 1"
                            class="display-flex-row align-items-baseline font-weight-light "
                          >
                            <span class="margin-right-xsmall">
                              {{ $t('mEditionProductPricesAndPlansVidroop.messages.plan.payout') }} {{ productoDivisas[index].divisa.simbolo }}
                            </span>
                            <AtomInputPrimary
                              v-model="planes[index].precio"
                              :disabled="buttonPrimary.sending"
                              inputClass="a-input-side text-align-right width-80-px"
                              :name="`precio-contado-${productoDivisa.divisa.iso_code}`"
                              placeholder="0.00"
                              type="text"
                              wrapperClass="a-input-wrapper-row margin-right-zero"
                              @keydown.enter.stop.prevent
                            />
                            <span class="margin-right-xsmall text-color-black-35">
                              {{ productoDivisas[index].divisa.iso_code }}
                            </span>
                          </span>

                          <!-- Cuotas -->
                          <span
                            v-show="!soloSuscripcion && !soloContado && formaDePago[index].value === 2"
                            class="display-flex-row align-items-baseline font-weight-light "
                          >
                            <AtomSelectPrimary
                              v-model.number="planes[index].cuotas"
                              :disabled="buttonPrimary.sending"
                              :elements="cuotas[index]"
                              inputClass="a-input-side"
                              keyField="id"
                              :name="`cuotas-${productoDivisa.divisa.iso_code}`"
                              textField="value"
                              wrapperClass="a-input-wrapper-row"
                            />
                            <span class="margin-right-xsmall">
                              {{ $t('mEditionProductPricesAndPlansVidroop.messages.plan.dues') }} {{ productoDivisas[index].divisa.simbolo }}
                            </span>
                            <AtomInputPrimary
                              v-model="planes[index].precio"
                              :disabled="buttonPrimary.sending"
                              inputClass="a-input-side text-align-right width-80-px"
                              :name="`precio-cuotas-${productoDivisa.divisa.iso_code}`"
                              placeholder="0.00"
                              type="text"
                              wrapperClass="a-input-wrapper-row margin-zero"
                              @keydown.enter.stop.prevent
                            />
                            <span class="margin-right-xsmall text-color-black-35">
                              {{ productoDivisas[index].divisa.iso_code }}
                            </span>
                          </span>

                          <!-- Suscripción -->
                          <span
                            v-show="!soloContado && formaDePago[index].value === 0"
                            class="display-flex-row-center font-weight-light"
                          >
                            <span>
                              {{ $t('mEditionProductPricesAndPlansVidroop.messages.plan.subscription.first') }} {{ productoDivisas[index].divisa.simbolo }}
                            </span>
                            <AtomInputPrimary
                              v-model="planes[index].precio"
                              :disabled="buttonPrimary.sending"
                              inputClass="a-input-side margin-left-xsmall margin-bottom-zero text-align-right width-80-px"
                              :name="`precioSuscripcion-${productoDivisa.divisa.iso_code}`"
                              placeholder="0.00"
                              type="text"
                              wrapperClass="a-input-wrapper-row margin-zero"
                              @keydown.enter.stop.prevent
                            />
                            <span class="margin-right-xsmall text-color-black-35">
                              {{ productoDivisas[index].divisa.iso_code }}
                            </span>
                            <span class="margin-right-xsmall">
                              {{ $t('mEditionProductPricesAndPlansVidroop.messages.plan.subscription.second') }}
                            </span>
                            <!-- Con IA mensual, de a un mes: el intervalo queda fijo en 1 -->
                            <AtomSelectPrimary
                              v-if="!soloMensual"
                              v-model.number="planes[index].intervalo"
                              :disabled="buttonPrimary.sending"
                              :elements="intervals"
                              inputClass="a-input-side"
                              keyField="id"
                              :name="`intervalo-${productoDivisa.divisa.iso_code}`"
                              textField="day"
                              wrapperClass="a-input-wrapper-row"
                            />
                            <AtomSelectPrimary
                              v-model.number="planes[index].frecuencia"
                              :disabled="buttonPrimary.sending"
                              :elements="frecuenciasDelPlan"
                              keyField="id"
                              :name="`frecuencia-${productoDivisa.divisa.iso_code}`"
                              textField="name"
                              wrapperClass="a-input-wrapper-row"
                            />
                          </span>

                          <button
                            class="a-button-secondary a-button-products-secondary margin-left-small"
                            href="#"
                            @click.prevent="addPlan(index)"
                            type="button"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>

                      </div>
                    </transition>

                  </div>

                  <h4 class="font-weight-bold text-color-products-primary">
                    {{ $t('mEditionProductPricesAndPlansVidroop.messages.currency.items.methods') }}
                  </h4>
                  <div class="display-flex-column list-item-edition-content">
                    <div v-if="!productoDivisa.pasarelas.length">
                      <p class="margin-bottom-zero margin-top-small font-weight-regular text-color-vidroop-primary">
                        {{ $t('mEditionProductPricesAndPlansVidroop.messages.paymentMethods.noPaymentMethodsCreated') }}
                      </p>
                      <router-link
                        class="display-flex-row-center font-size-small font-weight-bold margin-bottom-xlarge margin-top-medium text-color-success"
                        :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.paymentMethods.subject')}`"
                      >
                        <i class="fas fa-plus font-size-xsmall margin-right-xsmall"></i>
                        <span>
                          {{ $t('mEditionProductPricesAndPlansVidroop.links.paymentMethod') }}
                        </span>
                      </router-link>
                    </div>

                    <span
                      v-for="pasarela in productoDivisa.pasarelas"
                      :key="pasarela.id_academia_pasarela_pago"
                    >
                      <AtomCheckboxPrimary
                        v-if="pasarela.activa"
                        v-model="productoGestionesMediosDePago[index]"
                        :disabled="buttonPrimary.sending"
                        inputStyle="products"
                        :name="`mediodepago-${productoDivisa.divisa.id_divisa}[]`"
                        :text="pasarela.descripcion"
                        :value="pasarela.id_academia_pasarela_pago"
                        wrapperClass="margin-right-medium margin-top-small"
                      />
                    </span>
                  </div>

                  <h4 class="font-weight-bold text-color-products-primary">
                    {{ $t('mEditionProductPricesAndPlansVidroop.messages.currency.items.state') }}
                  </h4>
                  <div class="display-flex-column list-item-edition-content-last">
                    <AtomTogglePrimary
                      v-model="productoDivisa.gestion.activa"
                      :disabled="buttonPrimary.sending || !productoDivisa.updateStateAllowed"
                      name="activa"
                      slider-class="a-toggle-slider-products-primary"
                      switch-class="a-toggle-switch-left-primary"
                      type="checkbox"
                    />
                    <small
                      v-if="!productoDivisa.updateStateAllowed"
                      class="display-block font-weight-light margin-top-large"
                    >
                      <i>
                        {{ `${$t('mEditionProductPricesAndPlansVidroop.messages.currency.activation.first')}
                          productoDivisa.nombre ${$t('mEditionProductPricesAndPlansVidroop.messages.currency.activation.second')}` }}
                      </i>
                    </small>
                  </div>
                </div>
              </transition>
            </div>
          </div>

        </div>

        <!-- Step 4 -->
        <div class="m-edition-section-content-subject-step-connected">
          <h3>
            <span class="step-number">
              <i class="fas fa-check"></i>
            </span>
            <span
              v-if="+producto.precio.pago"
              key="step4Charge"
            >
              {{ $t('mEditionProductPricesAndPlansVidroop.steps.fourth') }}
            </span>
            <span
              v-else
              key="step2Free"
            >
              {{ $t('mEditionProductPricesAndPlansVidroop.steps.second.free') }}
            </span>
          </h3>

          <AtomTogglePrimary
            v-if="element.producto_vidroop && producto.precio.pago"
            v-model.number="producto.estado.cambio_plan"
            :disabled="!canUpdateProductoEstado || buttonPrimary.sending && +producto.estado.activo"
            name="cambio_plan"
            slider-class="a-toggle-slider-products-primary"
            switch-class="a-toggle-switch-left-primary"
            :text="+producto.estado.cambio_plan
              ? $t('mEditionProductPricesAndPlansVidroop.inputs.cambioPlan.label.checked')
              : $t('mEditionProductPricesAndPlansVidroop.inputs.cambioPlan.label.unchecked')"
            type="checkbox"
          />

          <AtomTogglePrimary
            v-model.number="producto.estado.activo"
            :disabled="!canUpdateProductoEstado || buttonPrimary.sending && +producto.estado.cambio_plan"
            name="activo"
            slider-class="a-toggle-slider-products-primary"
            switch-class="a-toggle-switch-left-primary margin-top-medium"
            :text="producto.estado.activo
              ? $t('mEditionProductPricesAndPlansVidroop.inputs.activo.label.checked')
              : $t('mEditionProductPricesAndPlansVidroop.inputs.activo.label.unchecked')"
            type="checkbox"
          />

          <AtomTogglePrimary
            v-show="+producto.estado.activo"
            v-model.number="producto.estado.visible"
            :disabled="!canUpdateProductoEstado || buttonPrimary.sending"
            name="visible"
            slider-class="a-toggle-slider-products-primary"
            switch-class="a-toggle-switch-left-primary margin-top-medium"
            :text="+producto.estado.visible
              ? $t('mEditionProductPricesAndPlansVidroop.inputs.visible.label.checked')
              : $t('mEditionProductPricesAndPlansVidroop.inputs.visible.label.unchecked')"
            type="checkbox"
          />

          <small
            v-if="element.producto_vidroop && producto.precio.pago"
            class="display-block font-weight-light margin-top-medium"
          >
            <i v-if="producto.estado.cambio_plan">{{ $t('mEditionProductPricesAndPlansVidroop.messages.active.changePlanOn') }}</i>
            <i v-else>{{ $t('mEditionProductPricesAndPlansVidroop.messages.active.changePlanOff') }}</i>
          </small>

          <small class="display-block font-weight-light margin-top-large">
            <i>{{ activeMessage }}</i>
          </small>

          <small
            v-if="productoCategoria === 0"
            class="display-block font-weight-regular margin-top-small text-color-assets-primary"
          >
            <i>
              {{ $t('mEditionProductPricesAndPlansVidroop.messages.active.disabled.card.text') }}
              <a
                class="text-link-hover-assets"
                href="#"
                @click.prevent="gotTo('card')"
              >
                <u>{{ $t('mEditionProductPricesAndPlansVidroop.messages.active.disabled.card.link') }}</u>
              </a>
            </i>
          </small>

          <small
            v-if="!productoProyectos.length && !tieneSatelites"
            class="display-block font-weight-regular margin-top-small text-color-assets-primary"
          >
            <i>
              {{ $t('mEditionProductPricesAndPlansVidroop.messages.active.disabled.assetsIncluded.text') }}
              <a
                class="text-link-hover-assets"
                href="#"
                @click.prevent="gotTo('assetsIncluded')"
              >
                <u>{{ $t('mEditionProductPricesAndPlansVidroop.messages.active.disabled.assetsIncluded.link') }}</u>
              </a>
            </i>
          </small>

        </div>

        <!-- Step 5 -->
        <div
          v-if="+producto.estado.activo"
          class="m-edition-section-content-subject-step-connected"
        >
          <h3>
            <span class="step-number">
              <i class="fas fa-link"></i>
            </span>
            <span
              v-if="+producto.precio.pago"
              key="step5Charge"
            >
              {{ $t('mEditionProductPricesAndPlansVidroop.steps.fifth.sale') }}
            </span>
            <span
              v-else
              key="step3Free"
            >
              {{ $t('mEditionProductPricesAndPlansVidroop.steps.third.free') }}
            </span>
          </h3>

          <div class="display-flex-column">
            <div class="align-items-baseline display-flex-row">
              <a
                class="font-weight-bold"
                :href="productoMarketPlaceUrl"
                target="_blank"
              >
                  <span class="text-link-hover-products">
                    {{ productoMarketPlaceUrl }}
                  </span>
              </a>
              <AtomButtonSecondary
                :button-secondary="buttonSecondary.copyMarket"
                @copyToClipboard="copyToClipboard(productoMarketPlaceUrl)"
              />
            </div>
            <small class="font-weight-light margin-top-medium">
              <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.urlMarket') }}</i>
            </small>
            <small class="display-block font-weight-bold margin-top-small text-color-danger">
              <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.active.reminder') }}</i>
            </small>
          </div>
        </div>

        <div
          v-else-if="+producto.estado.cambio_plan"
          class="m-edition-section-content-subject-step-connected"
        >
          <h3>
            <span class="step-number">
              <i class="fas fa-link"></i>
            </span>
            <span
              v-if="+producto.precio.pago"
              key="step5Charge"
            >
              {{ $t('mEditionProductPricesAndPlansVidroop.steps.fifth.changePlan') }}
            </span>
          </h3>

          <div class="display-flex-column">
            <div class="align-items-baseline display-flex-row">
              <a
                class="font-weight-bold"
                target="_blank"
              >
                  <span class="text-link-hover-products">
                    {{ productoChangePlanUrl }}
                  </span>
              </a>
              <AtomButtonSecondary
                :button-secondary="buttonSecondary.copyChangePlan"
                @copyToClipboard="copyToClipboard(productoChangePlanUrl)"
              />
            </div>
            <small class="font-weight-light margin-top-medium">
              <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.urlChangePlanOne') }}</i>
            </small>
            <small class="display-block font-weight-bold margin-top-small text-color-danger">
              <i>{{ $t('mEditionProductPricesAndPlansVidroop.messages.active.reminder') }}</i>
            </small>
          </div>
        </div>

        <div class="m-form-action">
          <AtomButtonPrimary
            :button-primary="buttonPrimary"
            :disabled="buttonPrimary.sending"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductPricesAndPlansVidroop',

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductPricesAndPlansVidroop.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        copyChangePlan: {
          class: 'a-button-secondary a-button-products-secondary a-button-side a-tooltip-primary a-tooltip-bottom margin-left-small',
          component: '',
          icon: 'fa fa-clipboard',
          method: 'copyToClipboard',
          text: '',
          tooltip: this.$t('mEditionProductPricesAndPlansVidroop.buttonSecondary.tooltip.copy'),
          type: 'button'
        },
        copyMarket: {
          class: 'a-button-secondary a-button-products-secondary a-button-side a-tooltip-primary a-tooltip-bottom margin-left-small',
          component: '',
          icon: 'fa fa-clipboard',
          method: 'copyToClipboard',
          text: '',
          tooltip: this.$t('mEditionProductPricesAndPlansVidroop.buttonSecondary.tooltip.copy'),
          type: 'button'
        }
      },

      cuotas: [],
      divisas: [],
      frequencyTypes: [],
      frequencyTypesTrial: [],
      formaDePago: [],
      intervals: [],
      pasarelas: [],
      pasarelasPorDivisa: [],
      planes: [],

      producto: {
        estado: {
          activo: 1,
          visible: 1,
          cambio_plan: 0
        },

        precio: {
          pago: 1,
          trial: {
            intervalo: 0,
            frecuencia: 1,
            pago: 0
          }
        }
      },

      productoCategoria: 0,
      productoDivisas: [],
      productoGestiones: [],
      productoGestionesMediosDePago: [],
      productoChangePlanUrl: '',
      productoMarketPlaceUrl: '',
      productoProyectos: [],
      puntosDeVenta: [],

      radioButtonPrimary: {
        formaDeVenta: {
          gratis: {
            labelClass: 'a-radiobutton-products-primary',
            name: 'forma-de-venta'
          },

          pago: {
            labelClass: 'a-radiobutton-products-primary',
            name: 'forma-de-venta'
          }
        },

        periodoPrueba: {
          gratis: {
            labelClass: 'a-radiobutton-products-primary',
            name: 'periodo'
          },

          sinPeriodo: {
            labelClass: 'a-radiobutton-products-primary',
            name: 'periodo'
          }
        }
      },

      showLoadingState: 0,
      trialPago: 0,
      i: 0
    }
  },

  computed: {
    activeMessage () {
      return !this.producto.estado.activo
        ? this.$t('mEditionProductPricesAndPlansVidroop.messages.active.inactive')
        : this.producto.estado.visible
          ? this.$t('mEditionProductPricesAndPlansVidroop.messages.active.visible')
          : this.$t('mEditionProductPricesAndPlansVidroop.messages.active.hidden')
    },

    canUpdateProductoEstado () {
      return (!+this.producto.precio.pago ||
          (+this.producto.precio.pago &&
            this.productoDivisas.some(pd => pd.gestion.activa))) &&
        this.productoCategoria > 0 &&
        (this.productoProyectos.length > 0 || this.tieneSatelites)
    },

    /*
     | Las frecuencias que se pueden elegir para la suscripcion.
     |
     | Con un satelite de suscripcion incluido, el producto se vende SOLO por suscripcion mensual o
     | anual: es la misma regla que aplica Producto::planAdmitidoPara() en el core, que rechaza el
     | resto. La IA mensual, ademas, solo mensual. Sin satelites se ofrecen las cuatro de siempre.
     */
    frecuenciasDelPlan () {
      // 3 = Mes(es), 4 = Año(s) en $filters.parameters.frequencies
      if (this.soloMensual) {
        return this.frequencyTypes.filter(f => f.id === 3)
      }

      if (this.soloSuscripcion) {
        return this.frequencyTypes.filter(f => f.id === 3 || f.id === 4)
      }

      return this.frequencyTypes
    },

    /*
     | Las reglas de cobro que imponen los satelites incluidos, leidas de las columnas satelite_* del
     | producto. Quien de verdad las aplica es el core (Producto::planAdmitidoPara() al crear o
     | reactivar un plan); aca solo se restringe lo que se ofrece, para no armar planes que despues
     | rechaza:
     |
     | - soloContado: un paquete de creditos de IA se vende en un solo pago de contado. Manda sobre
     |   soloSuscripcion; el core no deja combinar el paquete con otro satelite, asi que las dos
     |   juntas no deberian darse, pero si se dieran el editor no quedaria vacio.
     | - soloMensual: la IA mensual se vende de a un mes (sus creditos se renuevan el 1 de cada mes):
     |   frecuencia mensual e intervalo 1, fijos. El core aceptaria anual; es una regla de producto.
     | - soloSuscripcion: Juedroop, Evaluacion, Ruleta e IA mensual, sin contado ni cuotas.
     | - tieneIa: ni "Gratis" ni periodo de prueba. Cada venta entrega creditos y la IA cuesta plata:
     |   una IA mensual gratis o en prueba daria creditos todos los meses sin cobrar.
     | - tieneSatelites: cualquiera de ellos. Se puede vender sin proyectos, porque lo que se
     |   vende es el satelite: el requisito de "al menos un curso incluido" no aplica.
     */
    soloContado () {
      return !!this.element.satelite_ia_creditos
    },

    soloMensual () {
      return !this.soloContado && !!this.element.satelite_ia_mensual
    },

    soloSuscripcion () {
      return !this.soloContado && !!(this.element.satelite_juedroop ||
        this.element.satelite_evaluacion ||
        this.element.satelite_ruleta ||
        this.element.satelite_ia_mensual)
    },

    tieneIa () {
      return !!(this.element.satelite_ia_mensual || this.element.satelite_ia_creditos)
    },

    tieneSatelites () {
      return !!(this.element.satelite_juedroop ||
        this.element.satelite_evaluacion ||
        this.element.satelite_ruleta ||
        this.element.satelite_ia_mensual ||
        this.element.satelite_ia_creditos)
    },

    trialMessage () {
      return this.trialPago === 0
        ? this.$t('mEditionProductPricesAndPlansVidroop.messages.trial.free')
        : this.trialPago === 1
          ? this.$t('mEditionProductPricesAndPlansVidroop.messages.trial.charge')
          : this.$t('mEditionProductPricesAndPlansVidroop.messages.trial.non')
    }
  },

  watch: {
    'buttonSecondary.copyChangePlan.icon' () {
      if (this.buttonSecondary.copyChangePlan.icon === 'fa fa-check') {
        this.buttonSecondary.copyChangePlan.tooltip = this.$t('mEditionProductPricesAndPlansVidroop.buttonSecondary.tooltip.copied')
      } else if (this.buttonSecondary.copyChangePlan.icon === 'fa fa-clipboard') {
        this.buttonSecondary.copyChangePlan.tooltip = this.$t('mEditionProductPricesAndPlansVidroop.buttonSecondary.tooltip.copy')
      }
    },

    'buttonSecondary.copyMarket.icon' () {
      if (this.buttonSecondary.copyMarket.icon === 'fa fa-check') {
        this.buttonSecondary.copyMarket.tooltip = this.$t('mEditionProductPricesAndPlansVidroop.buttonSecondary.tooltip.copied')
      } else if (this.buttonSecondary.copyMarket.icon === 'fa fa-clipboard') {
        this.buttonSecondary.copyMarket.tooltip = this.$t('mEditionProductPricesAndPlansVidroop.buttonSecondary.tooltip.copy')
      }
    },

    canUpdateProductoEstado () {
      if (!this.canUpdateProductoEstado) {
        this.producto.estado.activo = 0
        this.producto.estado.visible = 0
        this.producto.estado.cambio_plan = 0
      }
    },

    element () {
      this.setProducto()
    },

    productoDivisas: {
      deep: true,

      handler () {
        if (this.showLoadingState >= 6) {
          this.canUpdateProductoGestionEstado()
        }
      }
    },

    productoGestionesMediosDePago: {
      deep: true,

      handler () {
        if (this.showLoadingState >= 6) {
          this.canUpdateProductoGestionEstado()
        }
      }
    },

    'producto.estado.activo' () {
      if (this.producto.estado.activo) {
        this.producto.estado.cambio_plan = +false
      }

      this.producto.estado.visible = this.producto.estado.activo
        ? this.producto.estado.visible
        : +false
    },

    'producto.estado.cambio_plan' () {
      if (this.producto.estado.cambio_plan) {
        this.producto.estado.activo = +false
      }
    },

    'producto.precio.pago' () {
      if (!this.producto.precio.pago) {
        this.producto.estado.cambio_plan = +false
      }
    },

    trialPago () {
      if (this.trialPago === 2) {
        this.producto.precio.trial.intervalo = 0
        this.producto.precio.trial.frecuencia = 3
      } else if (this.producto.precio.trial.intervalo === 0) {
        this.producto.precio.trial.intervalo = 1
      }
      this.producto.precio.trial.pago = +(this.trialPago === 1)
    }
  },

  created () {
    this.frequencyTypes = this.element.producto_vidroop
      ? [...this.$filters.parameters.frequencies].filter(f => f.id === 3 || f.id === 4)
      : [...this.$filters.parameters.frequencies]
    this.frequencyTypesTrial = [...this.$filters.parameters.frequencies]
    this.readDivisas()
    this.readPasarelas()
    this.setIntervals()
    this.setProducto()
    this.productoMarketPlaceUrl = `${this.$utils.getMarketPlaceDomain()}/${this.$store.getters.getAcademyData.url}/producto/${this.$route.params.id}/comprar`
    this.productoChangePlanUrl = `${this.$utils.getAppDomain()}/gestion/plan-personalizado/${this.$route.params.id}/cambiar`
  },

  methods: {
    addPlan (divisaIndex) {
      let planIsAdded = this.productoDivisas[divisaIndex].gestion.planes.find(plan =>
        plan.pago.cuotas === this.planes[divisaIndex].cuotas &&
        plan.pago.frecuencia === this.planes[divisaIndex].frecuencia &&
        plan.pago.intervalo === this.planes[divisaIndex].intervalo &&
        (plan.activo === true || plan.activo === undefined))

      if (this.planes[divisaIndex].precio.length && this.planes[divisaIndex].precio > 0 && planIsAdded === undefined) {
        this.productoDivisas[divisaIndex].gestion.planes.unshift({ pago: Object.assign({}, this.planes[divisaIndex]) })
        if (this.planes[divisaIndex].cuotas >= 2) {
          this.cuotas[divisaIndex].splice(this.cuotas[divisaIndex].findIndex(cuota =>
            cuota.value === this.planes[divisaIndex].cuotas), 1)
          this.planes[divisaIndex].cuotas = this.cuotas[divisaIndex][0].value
        }
        this.planes[divisaIndex].precio = ''
      }
    },

    canUpdateProductoGestionEstado () {
      this.productoDivisas.forEach((pd, index) => {
        if (pd.gestion.planes &&
          pd.gestion.planes.length > 0 &&
          (pd.gestion.planes.filter(plan =>
            plan.id_producto_gestion_plan && !plan.activo).length <
            pd.gestion.planes.length) &&
          pd.gestion.punto_venta !== undefined &&
          this.productoGestionesMediosDePago[index].length > 0) {
          this.productoDivisas[index].updateStateAllowed = true
        } else {
          this.productoDivisas[index].updateStateAllowed = false
        }
        this.productoDivisas[index].gestion.activa = this.productoDivisas[index].updateStateAllowed
          ? this.productoDivisas[index].gestion.activa
          : 0
      })
    },

    copyToClipboard (url) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(() => {
            return navigator.clipboard.readText()
          })
          .then((text) => {
            if (text === this.productoMarketPlaceUrl) {
              this.buttonSecondary.copyChangePlan.icon = 'fa fa-clipboard'
              this.buttonSecondary.copyMarket.icon = 'fa fa-check'
            } else if (text === this.productoChangePlanUrl) {
              this.buttonSecondary.copyMarket.icon = 'fa fa-clipboard'
              this.buttonSecondary.copyChangePlan.icon = 'fa fa-check'
            } else {
              this.buttonSecondary.copyMarket.icon = 'fa fa-clipboard'
              this.buttonSecondary.copyChangePlan.icon = 'fa fa-clipboard'
            }
          })
          .catch((err) => {
            console.log(err.message)
          })
      } else {
        console.log('La API de Clipboard no está soportada.')
      }
    },

    createProductoGestion (divisaIndex) {
      let gestion = this.setProductoGestion(this.productoDivisas[divisaIndex].divisa.iso_code, this.productoDivisas[divisaIndex].gestion, 'create')
      this.$services.create('producto', 'createProductoGestion', gestion, [this.$route.params.id])
        .then(response => {
          this.productoDivisas[divisaIndex].gestion.id_producto_gestion = response.data.id_producto_gestion
          this.recursionGestiones(divisaIndex - 1)
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
        })
    },

    createProductoGestionPlan (divisaIndex, planIndex) {
      this.$services.create('producto',
        'createProductoGestionPlan',
        this.productoDivisas[divisaIndex].gestion.planes[planIndex].pago,
        [this.$route.params.id,
          this.productoDivisas[divisaIndex].gestion.id_producto_gestion])
        .then(response => {
          this.recursionPlanes(divisaIndex, planIndex - 1)
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
        })
    },

    deleteProductoGestionPlan (divisaIndex, planIndex) {
      this.$services.delete(
        'producto',
        'deleteProductoGestionPlan',
        {},
        [this.$route.params.id,
          this.productoDivisas[divisaIndex].gestion.id_producto_gestion,
          this.productoDivisas[divisaIndex].gestion.planes[planIndex].id_producto_gestion_plan])
        .then(response => {
          this.recursionPlanes(divisaIndex, planIndex - 1)
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
        })
    },

    /*
     | La forma de pago con la que arranca el editor de planes de cada moneda.
     |
     | Un ProductoVidroop y un producto con un satelite de suscripcion se venden por suscripcion:
     | arrancan ahi. Con el satelite, ademas, Contado y Cuotas estan ocultos, y arrancar en 1 dejaba el
     | editor sin ningun campo a la vista hasta hacer clic en Suscripcion. Un paquete de creditos, al
     | reves: solo contado.
     */
    formaDePagoInicial () {
      if (this.soloContado) {
        return 1
      }

      return this.element.producto_vidroop || this.soloSuscripcion ? 0 : 1
    },

    getCurrencyValue (idDivisa) {
      return this.divisas.filter(divisa => divisa.iso_code === idDivisa)[0]
    },

    getProductoGestionPlanText (plan, simbolo, isoCode) {
      // TODO: Colocar texto en archivo de traducción
      if (plan.pago.cuotas === 0) {
        return `1 pago de ${simbolo} ${plan.pago.precio} ${isoCode} cada ${plan.pago.intervalo} ${this.$filters.getFrequencyValue(plan.pago.frecuencia, 'name')}`
      } else if (plan.pago.cuotas === 1) {
        return `1 pago de contado de ${simbolo} ${plan.pago.precio} ${isoCode}`
      } else {
        return `${plan.pago.cuotas} cuotas mensuales de ${simbolo} ${plan.pago.precio} ${isoCode}`
      }
    },

    gotTo (item) {
      if (item === 'card') {
        this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.card.subject')}`)
      } else if (item === 'assetsIncluded') {
        this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.assetsIncluded.subject')}`)
      }
    },

    recursionGestiones (divisaIndex) {
      if (this.productoDivisas.length - 1 === divisaIndex) {
        this.buttonPrimary.sending = true
      }

      if (this.producto.precio.pago && this.productoDivisas.length) {
        if (divisaIndex >= 0) {
          if (this.productoDivisas[divisaIndex].gestion.id_producto_gestion) {
            this.updateProductoGestion(divisaIndex)
          } else {
            this.createProductoGestion(divisaIndex)
          }
        } else {
          let planesLength = this.productoDivisas[this.productoDivisas.length - 1].gestion.planes
            ? this.productoDivisas[this.productoDivisas.length - 1].gestion.planes.length - 1
            : -1
          this.recursionPlanes(this.productoDivisas.length - 1, planesLength)
        }
      } else {
        this.updateProducto()
      }
    },

    recursionGestionesEstados (divisaIndex) {
      if (divisaIndex === -1) {
        this.updateProducto()
      } else {
        this.updateProductoGestionEstado(divisaIndex)
      }
    },

    recursionPasarelas (divisaIndex, pasarelaIndex) {
      if (divisaIndex >= 1 && pasarelaIndex === -1) {
        this.recursionPasarelas(divisaIndex - 1, this.productoDivisas[divisaIndex - 1].pasarelas.length - 1)
      } else if (divisaIndex === 0 && pasarelaIndex === -1) {
        this.recursionGestionesEstados(this.productoDivisas.length - 1)
      } else {
        let activa = this.productoGestionesMediosDePago[divisaIndex].includes(
          this.productoDivisas[divisaIndex].pasarelas[pasarelaIndex].id_academia_pasarela_pago)
        this.updateProductoGestionPasarelaEstado(activa, divisaIndex, pasarelaIndex)
      }
    },

    recursionPlanes (divisaIndex, planIndex) {
      if (divisaIndex >= 1 && planIndex === -1) {
        let planesLength = this.productoDivisas[divisaIndex - 1].gestion.planes
          ? this.productoDivisas[divisaIndex - 1].gestion.planes.length - 1
          : -1
        this.recursionPlanes(divisaIndex - 1, planesLength)
      } else if (divisaIndex === 0 && planIndex === -1) {
        this.recursionPasarelas(this.productoDivisas.length - 1
          , this.productoDivisas[this.productoDivisas.length - 1].pasarelas.length - 1)
      } else if (this.productoDivisas[divisaIndex].gestion.planes[planIndex].id_producto_gestion_plan) {
        if (!this.productoDivisas[divisaIndex].gestion.planes[planIndex].activo) {
          this.deleteProductoGestionPlan(divisaIndex, planIndex)
        } else {
          this.recursionPlanes(divisaIndex, planIndex - 1)
        }
      } else if (!this.productoDivisas[divisaIndex].gestion.planes[planIndex].id_producto_gestion_plan) {
        this.createProductoGestionPlan(divisaIndex, planIndex)
      }
    },

    /*
     | El plan con el que arranca el editor de cada moneda: tiene que coincidir con el radio que se ve
     | marcado (formaDePagoInicial).
     |
     | Con un Droop el radio arrancaba en Suscripcion pero el plan nacia como contado
     | ({ cuotas 1, frecuencia 0, intervalo 0 }) hasta que se tocaba el radio, con los selectores de
     | intervalo y frecuencia en blanco: el "+" agregaba un plan de contado que el core rechaza al
     | guardar. Ahora nace como suscripcion de 1 mes, y con un paquete de creditos, como contado.
     */
    planInicial () {
      if (this.soloContado) {
        return { cuotas: 1, frecuencia: 0, intervalo: 0, precio: '' }
      }

      if (this.soloSuscripcion) {
        return { cuotas: 0, frecuencia: 3, intervalo: 1, precio: '' }
      }

      return this.element.producto_vidroop
        ? { cuotas: 0, frecuencia: 0, intervalo: 0, precio: '' }
        : { cuotas: 1, frecuencia: 0, intervalo: 0, precio: '' }
    },

    readAcademiaPasarelasPorDivisa (divisaIndex, isoCode) {
      this.$services.read('academia', 'readAcademiaPasarelasPorDivisa', {}, [this.$store.getters.getAcademyData.id, isoCode])
        .then(response => {
          this.productoDivisas[divisaIndex].pasarelas = [...response.data]
        })
        .catch(error => {
          console.log(error)
        })
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = [...response.data]
          this.readPuntosVenta()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readPasarelas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProductoGestiones () {
      this.$services.read('producto', 'readProductoGestiones', {}, [this.$route.params.id])
        .then(response => {
          this.productoGestiones = [...response.data]
          this.productoDivisas.forEach((pd, index) => {
            let pgIndex = this.productoGestiones.findIndex(pg => pd.divisa.id_divisa === pg.divisa.id_divisa)
            if (pgIndex !== -1) {
              this.productoDivisas[index].gestion = Object.assign({}, this.productoGestiones[pgIndex])
              this.productoGestionesMediosDePago[index] = [...this.productoGestiones[pgIndex].pasarelas.map(pasarela => pasarela.id_academia_pasarela_pago)]
              this.formaDePago[index].show = this.element.producto_vidroop
                ? false
                : !(this.productoGestiones[pgIndex].planes && this.productoGestiones[pgIndex].planes.length)
            } else {
              this.$set(this.productoDivisas[index].gestion, 'activa', false)
              this.productoDivisas[index].gestion.punto_venta = this.puntosDeVenta.find(punto =>
                punto.divisa_vende
                  ? punto.divisa_vende.includes(this.productoDivisas[index].divisa.iso_code)
                  : punto.divisa.id_divisa === this.productoDivisas[index].divisa.id_divisa).id
              this.productoDivisas[index].gestion.planes = []
            }
            if (!this.element.producto_vidroop) {
              this.setCuotas(index)
            }
            this.planes.push(this.planInicial())
          })
          this.buttonPrimary.sending = false
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readPuntosVenta () {
      this.$services.read('puntoVenta', 'readPuntosVenta', {}, [this.$store.getters.getAcademyData.id, 1])
        .then(response => {
          this.puntosDeVenta = [...response.data]
          let pvDivisas = []
          this.puntosDeVenta.forEach(pv => {
            pv.divisa_vende.forEach(div => {
              pvDivisas.push(div)
            })
          })
          pvDivisas = [...new Set(pvDivisas)]
          pvDivisas.forEach((pvd, index) => {
            let div = this.getCurrencyValue(pvd)
            this.productoDivisas.push({ gestion: {},
              divisa: div,
              pasarelas: [],
              show: index === 0,
              updateStateAllowed: false })
            this.productoGestionesMediosDePago.push([])
            this.formaDePago.push({ value: this.formaDePagoInicial(), show: false })
            this.readAcademiaPasarelasPorDivisa(this.productoDivisas.length - 1, div.iso_code)
          })
          this.showLoadingState++
          this.readProductoGestiones()
        })
        .catch(error => {
          console.log(error)
        })
    },

    removePlan (divisaIndex, planIndex) {
      if (this.productoDivisas[divisaIndex].gestion.planes[planIndex].pago.cuotas >= 2) {
        this.cuotas[divisaIndex].push({ id: this.productoDivisas[divisaIndex].gestion.planes[planIndex].pago.cuotas,
          value: this.productoDivisas[divisaIndex].gestion.planes[planIndex].pago.cuotas })
        this.cuotas[divisaIndex].sort((a, b) => {
          if (a.value > b.value) {
            return 1
          }
          if (a.value < b.value) {
            return -1
          }
          return 0
        })
      }

      if (this.productoDivisas[divisaIndex].gestion.planes[planIndex].activo) {
        this.productoDivisas[divisaIndex].gestion.planes[planIndex].activo = false
      } else {
        this.productoDivisas[divisaIndex].gestion.planes.splice(planIndex, 1)
      }
      this.productoDivisas[divisaIndex].gestion = Object.assign({}, this.productoDivisas[divisaIndex].gestion)
    },

    setCuotas (divisaIndex) {
      this.cuotas[divisaIndex] = []
      for (let index = 2; index < 49; index++) {
        if (this.productoDivisas[divisaIndex].gestion.planes &&
          this.productoDivisas[divisaIndex].gestion.planes.find(plan => plan.pago.cuotas === index) === undefined) {
          this.cuotas[divisaIndex].push({ id: index, value: index })
        }
      }
    },

    setIntervals () {
      for (let index = 1; index < 31; index++) {
        this.intervals.push({ id: index, day: index })
      }
      this.showLoadingState++
    },

    setPlan (divisaIndex) {
      switch (this.formaDePago[divisaIndex].value) {
        case 0:
          // suscripción
          this.planes[divisaIndex].cuotas = parseInt(this.formaDePago[divisaIndex].value)
          this.planes[divisaIndex].frecuencia = 3
          this.planes[divisaIndex].intervalo = 1
          break

        case 1:
          // contado
          this.planes[divisaIndex].cuotas = parseInt(this.formaDePago[divisaIndex].value)
          this.planes[divisaIndex].frecuencia = 0
          this.planes[divisaIndex].intervalo = 0
          break

        case 2:
          // cuotas
          this.planes[divisaIndex].cuotas = this.cuotas[divisaIndex][0].value
          this.planes[divisaIndex].frecuencia = 3
          this.planes[divisaIndex].intervalo = 1
          break
      }
    },

    setProducto () {
      this.producto.estado.activo = +this.element.activo
      this.producto.estado.visible = +this.element.visible
      this.producto.precio.pago = +this.element.pago
      this.producto.estado.cambio_plan = +this.element.cambio_plan
      this.producto.precio.trial.intervalo = this.element.trial_intervalo
      this.producto.precio.trial.frecuencia = this.element.trial_frecuencia
      this.producto.precio.trial.pago = +this.element.trial_pago
      this.productoCategoria = this.element.categoria ? this.element.categoria.id_producto_categoria : 0
      this.productoProyectos = this.element.proyectos ? [...this.element.proyectos] : []
      this.trialPago = this.element.trial_intervalo === 0 ? 2 : +this.element.trial_pago
      // Con IA no hay "Gratis" ni periodo de prueba (las dos opciones se ocultan): si el producto venia
      // configurado asi de antes de incluirla, se muestra corregido y queda asi al guardar
      if (this.tieneIa) {
        this.producto.precio.pago = 1
        this.trialPago = 2
      }
      this.showLoadingState++
    },

    setProductoGestion (divisa, gestion, request) {
      let productoGestion = {}
      productoGestion.divisa = divisa
      productoGestion.punto_venta = gestion.punto_venta
      productoGestion.trial_precio = 0.00

      if (request === 'update') {
        productoGestion.id_gestion = gestion.id_producto_gestion
      }

      return productoGestion
    },

    toggleProductoDivisa (divisaIndex) {
      this.productoDivisas[divisaIndex].show = !this.productoDivisas[divisaIndex].show
    },

    toggleFormaDePago (divisaIndex) {
      this.formaDePago[divisaIndex].show = !this.formaDePago[divisaIndex].show
      if (this.formaDePago[divisaIndex].show && this.element.producto_vidroop) {
        this.planes[divisaIndex].frecuencia = 3
        this.planes[divisaIndex].intervalo = 1
      }
    },

    updateProducto () {
      this.producto.precio.trial.frecuencia = this.producto.precio.trial.frecuencia === 0
        ? 3
        : this.producto.precio.trial.frecuencia

      if (!this.producto.precio.pago) {
        this.producto.estado.cambio_plan = 0
      }

      this.$services.update('producto', 'updateProducto', { producto: this.producto }, [this.$route.params.id])
        .then(response => {
          this.$modal.updateData('readElement')
          if (this.producto.precio.pago) {
            this.readProductoGestiones()
          } else {
            this.buttonPrimary.sending = false
          }
          this.$emit('updateElement', response.data)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'success')
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
        })
    },

    updateProductoGestion (divisaIndex) {
      let gestion = this.setProductoGestion(this.productoDivisas[divisaIndex].divisa.iso_code, this.productoDivisas[divisaIndex].gestion, 'update')
      this.$services.update('producto', 'updateProductoGestion', gestion, [this.$route.params.id, gestion.id_gestion])
        .then(response => {
          this.recursionGestiones(divisaIndex - 1)
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
          this.buttonPrimary.sending = false
        })
    },

    updateProductoGestionEstado (divisaIndex) {
      this.$services.update('producto', 'updateProductoGestionEstado'
        , { activa: this.productoDivisas[divisaIndex].gestion.activa }
        , [this.$route.params.id, this.productoDivisas[divisaIndex].gestion.id_producto_gestion])
        .then(response => {
          this.recursionGestionesEstados(divisaIndex - 1)
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
        })
    },

    updateProductoGestionPasarelaEstado (activa, divisaIndex, pasarelaIndex) {
      this.$services.create(
        'producto'
        , 'updateProductoGestionPasarelaEstado'
        , { activa: activa }
        , [this.$route.params.id,
          this.productoDivisas[divisaIndex].gestion.id_producto_gestion,
          this.productoDivisas[divisaIndex].pasarelas[pasarelaIndex].id_academia_pasarela_pago])
        .then(response => {
          this.recursionPasarelas(divisaIndex, pasarelaIndex - 1)
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPricesAndPlansVidroop', 'updateProducto', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
        })
    }
  }
}
</script>
